export const getPaginateList = (appsData, currentPage, itemsPerPage) => {
  let filterApplictions = [];

  appsData.forEach((e, index) => {
    if (
      index >= itemsPerPage * (currentPage - 1) &&
      index <= itemsPerPage * (currentPage - 1) + itemsPerPage - 1
    ) {
      filterApplictions.push(e);
    }
  });

  let newList = {
    page: currentPage,
    data: filterApplictions.length > 0 ? filterApplictions : null,
    size: appsData.length,
    totalPages: appsData.length / itemsPerPage
  };

  return newList;
};
